import { default as DesktopWhatsAppComp } from './desktopIcon';
import { default as MobileWhatsAppComp } from './mobileIcon';

export { DesktopWhatsAppComp, MobileWhatsAppComp };
